import React from 'react'

export const I = ({ children }: { children: any }) => {
  return (
    <div>
      <div
        style={{
          height: '100%',
          width: '20px',
          display: 'inline-block',
          float: 'left'        }}
      >
        <i className='circle icon inList' />
      </div>
      {children && (
        <div
          style={{
            float: 'left',
            width: 'calc(100% - 20px)',
            marginBottom: '10px',
            fontFamily:'var(--chart-font-stack)'
  
          }}
        >
          {' '}
          {children}
        </div>
      )}
    </div>
  )
}
